import { useState, useEffect } from 'react';
import MUITable from '../../../Common/MUITable';
import Loader from "../../../Common/Loader/loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from 'react-toastify';
import 'jspdf-autotable';
import isGHMC from '../../../Common/helper/helpar';
import AddEditOperationModal from './AddEditOperationModal';
import ExportOperation from './ExportOperation';
import { GetOperations } from '../AttendanceApis';

const Operations = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [operationTableData, setOperationTableData] = useState([]);
    const [showAddEditModal, setShowAddEditModal] = useState(false);
    const [editOperationTableRow, setEditOperationTableRow] = useState(null);
    const [isOperationEditMode, setIsOperationEditMode] = useState(false);
    const isProd = isGHMC();
    const [filters, setFilters] = useState({
        IsActive: "",
    });

    let storedPermissions = localStorage.getItem("permissionId");
    const permissionValues1 =
        JSON.parse(localStorage.getItem("rolePermissions")) || {};
    let canWriteValue = null;

    // Convert storedPermissions to a number (if needed)
    storedPermissions = parseInt(storedPermissions, 10);

    // Find the matching roleToPermissionMapping object
    const matchingPermission = permissionValues1.find(
        (mapping) => mapping.permissionId === storedPermissions
    );

    if (matchingPermission) {
        canWriteValue = matchingPermission.canWrite;
    } else {
        console.log(`No match found for permission ID ${storedPermissions}`);
    }

    // Fetch operation data when the component mounts
    const fetchOperations = async (IsActive) => {
        setIsLoading(true);
        try {
            const data = await GetOperations(IsActive);
            setOperationTableData(data.data); // Populate table data
        } catch (error) {
            console.error('Error loading operations:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchOperations();
    }, []);

    const columns = [
        {
            label: "Operation",
            field: "operationName",
        },
        {
            label: "Status",
            render: (row) => row.isActive ? "Active" : "InActive",
        },
        {
            label: "Action",
            render: (row) => (
                <button
                    title='Edit'
                    className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
                    onClick={() => handleEdit(row)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            ),
        },
    ];

    // Handle Filters
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    // Handle Edit button click
    const handleEdit = (row) => {
        setEditOperationTableRow(row); // Set the operation row to edit
        setShowAddEditModal(true); // Show the edit modal
        setIsOperationEditMode(true);
    };

    return (
        <>
            <div className="content">
                <div className="page-content">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-end align-items-end mb-3 mt-3">
                                {canWriteValue ?
                                    <button
                                        className="button-container"
                                        onClick={() => { setEditOperationTableRow(null); setShowAddEditModal(true); setIsOperationEditMode(false); }}
                                    >
                                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                                        Add Operation
                                    </button>
                                    : ""}
                                <ExportOperation operationTableData={operationTableData} />
                            </div>
                        </div>
                    </div>
                    <div className="card shadow">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <select
                                            name="IsActive"
                                            value={filters.status}
                                            onChange={handleFilterChange}
                                            className="form-select"
                                        >
                                            <option value="" label="Select Status" />
                                            <option value="true" label="Active" />
                                            <option value="false" label="InActive" />
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3 mb-3 text-start">
                                    <button type="button" className={`btn  search ${isProd ? "search-ghmc" : "search-swm"}`} onClick={() => fetchOperations(filters.IsActive)}>Search</button>
                                </div>
                            </div>
                            <div className="top-header">
                                <span>Operation Details</span>
                            </div>
                            <MUITable
                                needSRNumber
                                rows={operationTableData}
                                columns={columns}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <AddEditOperationModal
                setOperationTableData={fetchOperations}
                showAddEditModal={showAddEditModal}
                setShowAddEditModal={setShowAddEditModal}
                editOperationTableRow={editOperationTableRow}
                setEditOperationTableRow={setEditOperationTableRow}
                isOperationEditMode={isOperationEditMode}
                setIsOperationEditMode={setIsOperationEditMode}
            />
            <ToastContainer />
            {isLoading && <Loader />}
        </>
    );
};

export default Operations;
